// Sujetos (recursos) de la aplicación para CASL

export const Subjects = {
  // Dashboard y navegación
  Dashboard: 'Dashboard',

  // Control de acceso
  AccessControl: 'AccessControl',
  AccessLog: 'AccessLog',
  AccessDevice: 'AccessDevice',
  AccessDoor: 'AccessDoor',
  AccessLevel: 'AccessLevel',
  RfidCredential: 'RfidCredential',
  LicensePlate: 'LicensePlate',

  // Invitados
  Guest: 'Guest',

  // Amenidades
  Amenity: 'Amenity',
  Reservation: 'Reservation',

  // Pagos
  Payment: 'Payment',
  Charge: 'Charge',

  // Comunicación
  Announcement: 'Announcement',
  Poll: 'Poll',
  TransparencyProject: 'TransparencyProject',
  TransparencyComment: 'TransparencyComment',
  Notification: 'Notification',
  NotificationConfig: 'NotificationConfig',

  // Tickets
  Ticket: 'Ticket',

  // Documentos
  Document: 'Document',

  // Usuarios y unidades
  User: 'User',
  Resident: 'Resident',
  Staff: 'Staff',
  ResidentMenu: 'ResidentMenu',
  StaffMenu: 'StaffMenu',
  RoleMenu: 'RoleMenu',
  Role: 'Role',
  Unit: 'Unit',
  /** Sección de un condominio — los SECTION_ADMIN la administran de forma acotada. */
  Section: 'Section',
  /** Asignar/transferir el residente principal de una unidad — el backend la valida con action 'manage'. */
  UnitPrincipal: 'UnitPrincipal',
  /** Asignar/quitar puertas (AccessDevice) a una unidad — separado de AccessDevice para no exponer la administración de puntos de acceso. */
  UnitAllowedDevice: 'UnitAllowedDevice',
  Profile: 'Profile',

  // Mascotas
  Pet: 'Pet',

  // Miembros del hogar
  HouseholdMember: 'HouseholdMember',

  // Vehículos
  Vehicle: 'Vehicle',

  // Configuración
  Settings: 'Settings',
  Branding: 'Branding',
  FiscalData: 'FiscalData',

  // Auditoría
  AuditLog: 'AuditLog',

  // Reportes
  Report: 'Report',

  // Guard Panel
  GuardPanel: 'GuardPanel',
  Restriction: 'Restriction',
  EmergencyAlert: 'EmergencyAlert',
  Shift: 'Shift',

  // Bitácora del Guardia
  Logbook: 'Logbook',
  PatrolCheckpoint: 'PatrolCheckpoint',
  PatrolRound: 'PatrolRound',
  // Recorridos GPS: solo el admin los supervisa (manage all); el guardia ve los suyos en la app
  GuardRoute: 'GuardRoute',

  // Proveedores
  Supplier: 'Supplier',
  SupplierEmployee: 'SupplierEmployee',
  SupplierVisit: 'SupplierVisit',

  // Inventario
  Asset: 'Asset',
  AssetCategory: 'AssetCategory',
  AssetMaintenance: 'AssetMaintenance',
  Consumable: 'Consumable',
  StockMovement: 'StockMovement',

  // Finanzas adicionales (sincronizado con backend)
  Expense: 'Expense',
  Billing: 'Billing',
  Invoice: 'Invoice',
  BillingPlan: 'BillingPlan',
  Cfdi: 'Cfdi',
  Webhook: 'Webhook',

  // Integraciones / plataforma
  Integration: 'Integration',
  ApiKey: 'ApiKey',

  // Cámaras en Vivo (HikCentral)
  Camera: 'Camera',

  // Routines / Scheduled Jobs (CAP-023)
  Routine: 'Routine',
  RoutineExecution: 'RoutineExecution',

  // Cobranza (gestión de morosos — solo admin vía manage 'all')
  Cobranza: 'Cobranza',

  /** "Ver como" — un admin previsualiza la app con la sesión de otro miembro del tenant. */
  Impersonation: 'Impersonation',

  // Comodín para permisos globales
  All: 'all',
} as const;

export type SubjectType = typeof Subjects[keyof typeof Subjects];
